<template>
<div v-if="dataLoaded">
    <table-page
        :client="client"
        @updated="getData"
        :warnings="warnings"
        :changelogs="changelogs"
        :hideTabs="true"
    >
        <fast-table
            :recordLabel="recordLabel"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentRowId"
            @click="currentRowId = $event.id"
        >
            <template v-slot:table-actions>
                <button class="btn btn-primary btn-collapse" id="addButton" @click="addModalOpen = true">
                    <i class="far fa-fw fa-plus"></i> <span class="btn-text">Add Pay Group</span>
                </button>
            </template>
        </fast-table>

        <add-form-modal
            v-if="addModalOpen"
            :client="client"
            @updated="$emit('updated'); getData()"
            @close="addModalOpen = false"
        />
    </table-page>

    <sidebar
        v-if="currentRowId"
        :client="client"
        :paygroup-id="currentRowId"
        @updated="getData"
        @close="currentRowId = null"
    >
    </sidebar>
</div>
</template>

<script>
import TablePageMixin from '@/mixins/TablePageMixin'
import FastTable from '@/components/FastTable'
import Sidebar from './components/Paygroups/Sidebar'
import AddFormModal from './components/Paygroups/AddFormModal'

export default {
    components: {FastTable, Sidebar, AddFormModal},
    mixins: [TablePageMixin],
    props: ['client'],
    computed: {
        currentRow() {
            return this.paygroups.find(x => (x.id == this.currentRowId))
        },
        sections() {
            return [
                {title: 'Active', defaultIsClosed: false, id: 'active', hasDateFilter: false},
                {title: 'Inactive', defaultIsClosed: true, id: 'inactive', hasDateFilter: false},
            ]
        },
        tableData() {
            const tableData = []

            const sections = [
                this.paygroups.filter(obj => obj.is_active),
                this.paygroups.filter(obj => !obj.is_active),
            ]

            sections.forEach((section, idx) => {
                const sectionData = []

                section.forEach(obj => {
                    const company = this.client.companies.find(c => c.id == obj.company_id)
                    sectionData.push({
                        id: obj.id,
                        object: obj,
                        cells: [
                            obj.name,
                            company.name,
                            obj.pay_frequency_pretty,
                        ],
                    })
                })

                tableData.push(sectionData)
            })

            return tableData
        },
    },
    data() {
        return {
            paygroups: [],
            dataLoaded: false,
            currentRowId: null,
            recordLabel: "Pay groups",
            headers: [
                {label: 'Pay Group', classes: '', isSearchable: true, defaultSort: true},
                {label: 'Company', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Pay Frequency', classes: '', isSearchable: false, isFilterable: true},
            ],
            addModalOpen: false,
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Pay Groups')
        this.getData()
    },
    methods: {
        getData() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/paygroups`).then(resp => {
                this.dataLoaded = true
                this.paygroups = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                }
                else {
                    this.$bus.showError(errors.__all__)
                }
            })
        },
    },
}
</script>
